import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-job-filter-nav',
  templateUrl: './job-filter-nav.component.html',
  styleUrls: ['./job-filter-nav.component.scss'],
})
export class JobFilterNavComponent implements OnInit {
  @Input() filters: Array<any> = [];

  constructor() {}

  ngOnInit(): void {}
}
